define('TescoMobile_Checkout/js/view/cvv-step',['jquery', 'Magento_Ui/js/form/form', 'Magento_Checkout/js/model/step-navigator', 'mage/translate', '../model/payment-information', 'uiRegistry', '../action/place-order', '../action/check-order-status', '../action/credit-check', 'mage/url', 'Magento_Checkout/js/model/quote', 'Magento_Checkout/js/view/summary/abstract-total', '../action/process-payment-error', 'Magento_Checkout/js/model/full-screen-loader', '../model/cancelled-order-processor', '../model/create-callback-url'], function ($, Component, stepNavigator, $t, paymentInformation, registry, placeOrderAction, checkOrderStatusAction, creditCheck, urlBuilder, quote, abstractTotal, processPaymentErrorAction, fullScreenLoader, cancelledOrderProcessor, createCallbackUrl) {
  'use strict';

  var _checkoutConfig$tesco, _checkoutConfig$tesco2;
  const checkoutConfig = window.checkoutConfig,
    cmsBlockPeaceOfMindContent = (_checkoutConfig$tesco = checkoutConfig === null || checkoutConfig === void 0 || (_checkoutConfig$tesco2 = checkoutConfig.tescomobile) === null || _checkoutConfig$tesco2 === void 0 || (_checkoutConfig$tesco2 = _checkoutConfig$tesco2.peace_of_mind_content) === null || _checkoutConfig$tesco2 === void 0 ? void 0 : _checkoutConfig$tesco2.main_content) !== null && _checkoutConfig$tesco !== void 0 ? _checkoutConfig$tesco : '';
  let isLoading = false;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/cvv-step',
      visible: false,
      paymentIframeUrl: paymentInformation.paymentIframeUrl,
      cmsBlock: cmsBlockPeaceOfMindContent || '',
      hasPayment: true,
      error: null,
      retry: false,
      orderStatusMaxRetries: 3,
      orderStatusRetryDelayMs: 300,
      orderStatusRetryCount: 0,
      orderStatusMaxRetriesExceededContent: '',
      retryAction: 'goToCardDetails'
    },
    initialize: function () {
      this._super();
      stepNavigator.registerStep('payment', 'payment', $t('Taking today\'s payment'), this.visible, _.bind(this.navigate, this), this.sortOrder);
      const grandTotal = abstractTotal().getTotals().base_grand_total;
      this.todayTotal = abstractTotal().getFormattedPrice(grandTotal);
      this.hasPayment(grandTotal > 0);
      window.addEventListener('message', function (event) {
        var _event$data, _event$data2;
        if (event.origin !== window.BASE_URL.replace(/\/$/, '')) {
          return;
        }
        if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.status) === 'cvv-capture-success') {
          $('body').trigger('dl-checkout-todays-payment-submit');
          this.placeOrder();
        } else if (((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.status) === 'cvv-capture-error') {
          processPaymentErrorAction(event.data.code).done(function (response) {
            $('body').trigger('dl-checkout-payment-failed-' + response.retry);
            this.retry(response.retry);
            this.retryAction = 'goToCardDetails';
            this.error(response.message);
          }.bind(this));
        }
      }.bind(this));
    },
    initObservable: function () {
      return this._super().observe(['visible', 'paymentIframeUrl', 'hasPayment', 'error', 'retry']);
    },
    navigate: function (step) {
      if (isLoading) {
        return;
      }
      const messageContainer = registry.get('checkout.errors').messageContainer;
      if (!this.paymentIframeUrl()) {
        isLoading = true;
        creditCheck(messageContainer).done(function (response) {
          step === null || step === void 0 ? void 0 : step.isVisible(true);
          if (response.payment_iframe_url) {
            paymentInformation.paymentIframeUrl(createCallbackUrl.payment(response.payment_iframe_url));
          } else if (['CO_141', 'CO_145'].includes(response.response_code)) {
            cancelledOrderProcessor.setMessage(response);
          } else if (response.response_code === 'CO_140') {
            this.placeOrder();
          }
        }.bind(this)).always(function () {
          isLoading = false;
        });
      } else {
        step === null || step === void 0 ? void 0 : step.isVisible(true);
      }
    },
    placeOrder: function () {
      const messageContainer = registry.get('checkout.errors').messageContainer;
      checkOrderStatusAction(messageContainer).done(function (response) {
        if (response.order_status === 'ORDER_COMPLETE' && response.account_number) {
          this.completeOrder(response.account_number, response.order_status);
        } else if (response.order_status === 'ORDER_CANCELLED') {
          cancelledOrderProcessor.setMessage(response);
        } else {
          if (this.orderStatusRetryCount < this.orderStatusMaxRetries) {
            fullScreenLoader.startLoader();
            setTimeout(function () {
              this.orderStatusRetryCount++;
              this.placeOrder();
            }.bind(this), this.orderStatusRetryDelayMs);
          } else {
            fullScreenLoader.stopLoader();
            this.retryAction = 'retryPlaceOrder';
            this.retry(true);
            this.error(this.orderStatusMaxRetriesExceededContent);
          }
        }
      }.bind(this));
    },
    placeZeroPaymentOrder: function () {
      const messageContainer = registry.get('checkout.errors').messageContainer;
      creditCheck(messageContainer).done(function (response) {
        this.completeOrder(response.account_number, 'ORDER_COMPLETE');
      }.bind(this));
    },
    goToCardDetails: function () {
      var _window;
      this.error(null);
      this.retry(false);
      this.paymentIframeUrl(null);
      if ((_window = window) !== null && _window !== void 0 && _window.wpwlOptions) {
        delete window.wpwlOptions;
      }
      paymentInformation.lockedSteps.push('card-payment');
      paymentInformation.cardDetailsRetry(true);
      stepNavigator.navigateTo('card-payment');
    },
    completeOrder: function (accountNumber, orderStatus) {
      const messageContainer = registry.get('checkout.errors').messageContainer;
      placeOrderAction(accountNumber, orderStatus, messageContainer);
    },
    executeRetryAction: function () {
      this[this.retryAction]();
    },
    retryPlaceOrder: function () {
      this.orderStatusRetryCount = 0;
      this.error(null);
      this.retry(false);
      this.placeOrder();
    }
  });
});

